import { Container } from "pixi.js";

export type MaxSize = {width: number, height: number};

export class BoundedContainer extends Container {
    _maxSize: MaxSize;

    set maxSize(value: MaxSize) {
        this._maxSize = value;
    }

    get maxSize() {
        return this._maxSize;
    }

    constructor(maxSize: MaxSize) {
        super();
        this._maxSize = maxSize;
    }

    update() {
        this.scale.set(1);
        const heightRatio = Math.max(1, this.width / this._maxSize.width);
        const widthRatio = Math.max(1, this.height / this._maxSize.height);
        const ratio = Math.max(1, widthRatio, heightRatio);
        this.scale.set(1 / ratio, 1 / ratio);
    }
}